import { render, staticRenderFns } from "./ProfileInfoContacts.vue?vue&type=template&id=d1be9bec&scoped=true&"
import script from "./ProfileInfoContacts.vue?vue&type=script&lang=js&"
export * from "./ProfileInfoContacts.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInfoContacts.vue?vue&type=style&index=0&id=d1be9bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1be9bec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1be9bec')) {
      api.createRecord('d1be9bec', component.options)
    } else {
      api.reload('d1be9bec', component.options)
    }
    module.hot.accept("./ProfileInfoContacts.vue?vue&type=template&id=d1be9bec&scoped=true&", function () {
      api.rerender('d1be9bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/ProfileInfoContacts.vue"
export default component.exports